module.exports = [
  {
    name: "Sniper Rifle",
    src: "weapon_1",
    icon: "icon_1",
    sound: "weapon_1",
    secondary: false,
    noSpread: false,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 100,
      spd: 2.5,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 7000,
      snd: 0,
    },
    akimbo: false,
    noAim: false,
    animWhileAim: true,
    trail: true,
    flap: {
      src: "flap_0",
      rot: 2.1,
      scl: 1,
      zOff: 0.43,
      xOff: 0.17,
      yOff: 0.53,
    },
    physRang: 0,
    physPow: 0,
    noAo: true,
    nAuto: true,
    type: 0,
    scope: true,
    swapTime: 300,
    aimSpd: 120,
    spdMlt: 0.95,
    ammo: 3,
    dmg: 100,
    hsMlt: 1.5,
    pierce: 0.2,
    reload: 1500,
    range: 1000,
    dropStart: 230,
    dmgDrop: 30,
    scale: 0.00115608717587935,
    leftHoldY: -0.65,
    rightHoldY: -0.68,
    leftHoldZ: 2.1,
    rightHoldZ: 0.75,
    holdW: 1,
    xOff: 0.8,
    yOff: -0.65,
    zOff: -1.8,
    xOrg: 0,
    yOrg: -0.55,
    zOrg: -0.8,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    inspectR: 0.2,
    inspectM: 0.1,
    muzOff: 8,
    muzMlt: 1.6,
    rate: 900,
    spread: 260,
    zoom: 2.7,
    leanMlt: 1.5,
    recoil: 0.009,
    recoilR: 0.05,
    recover: 0.993,
    recoverY: 0.997,
    recoverF: 0.975,
    recoilYM: 0.55,
    recoilZ: 1.5,
    recoilAnim: {
      time: 280,
      aimTime: 500,
      recoilTweenY: 0.24,
    },
    jumpYM: 0.15,
    rumble: 0.9,
    rumbleDur: 500,
    icnPad: 9,
  },
  {
    name: "Assault Rifle",
    src: "weapon_2",
    icon: "icon_2",
    sound: "weapon_2",
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 23,
      spd: 2.6,
      lookDir: true,
      grav: 0.00011,
      scale: 1.4,
      length: 10,
      range: 3000,
      snd: 0,
    },
    secondary: false,
    noSpread: false,
    akimbo: false,
    noAim: false,
    noAo: true,
    nAuto: false,
    physRang: 0,
    physPow: 0,
    swapWiggle: 0.3,
    attach: 0,
    attachYOff: -0.07,
    attachZOff: -0.8,
    zRot: 1,
    type: 0,
    swapTime: 300,
    aimSpd: 130,
    spdMlt: 0.95,
    ammo: 30,
    rate: 110,
    reload: 1400,
    dmg: 23,
    hsMlt: 1.5,
    pierce: 1,
    range: 700,
    dmgDrop: 5,
    scale: 0.00095745145728643,
    leftHoldY: -0.41,
    rightHoldY: -0.6,
    leftHoldZ: 0.5,
    rightHoldZ: -1.2,
    holdW: 0.8,
    xOff: 0.7,
    yOff: -0.87,
    zOff: -3.33,
    rotOff: -0.08,
    rotOffA: -0.035,
    aimOffY: 0.042,
    yRot: 0.0018,
    xOrg: 0,
    yOrg: -0.59,
    zOrg: -2.14,
    cLean: 0.2,
    cRot: 0.1,
    cDrop: 0.1,
    inspectR: 0.1,
    inspectM: 1.5,
    caseZOff: -1.7,
    caseYOff: -0.2,
    muzOff: 5.1,
    muzOffY: -0.05,
    muzMlt: 1.4,
    spread: 100,
    minSpread: 5,
    zoom: 1.6,
    leanMlt: 1.5,
    recoil: 0.003,
    recoilR: 0.05,
    recover: 0.978,
    recoverY: 0.995,
    recoverF: 0.975,
    jYMlt: 0.9,
    recoilYM: 0.6,
    recoilZ: 4.3,
    recoilZM: -0.04,
    aimRecMlt: 0.65,
    recoilAnim: {
      time: 160,
      recoilTweenY: 0.065,
      recoilTweenZ: 0.1,
    },
    jumpYM: 0.3,
    rumble: 0.5,
    icnPad: 5,
  },
  {
    name: "Pistol",
    src: "weapon_3",
    icon: "icon_3",
    sound: "weapon_3",
    secondary: true,
    noSpread: false,
    akimbo: false,
    noAim: false,
    noAo: true,
    transp: true,
    nAuto: true,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 12,
      spd: 2.3,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 1600,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    kill: ["", 75],
    swapWiggle: 0.3,
    type: 1,
    shine: 10,
    swapTime: 260,
    aimSpd: 110,
    spdMlt: 1.05,
    ammo: 10,
    reload: 700,
    dmg: 20,
    hsMlt: 1.5,
    range: 700,
    dmgDrop: 10,
    scale: 0.0003158947055276376,
    leftHoldY: -1.1,
    rightHoldY: -0.62,
    leftHoldZ: -0.3,
    rightHoldZ: -0.32,
    rightHoldX: 0.13,
    holdW: 1.3,
    xOff: 1.2,
    yOff: -0.6,
    zOff: -3.7,
    xOrg: 0,
    yRot: -0.005,
    yOrg: -0.23,
    zOrg: -3.9,
    jYMlt: 0.1,
    cLean: 0.3,
    cRot: 0.3,
    caseZOff: 0.2,
    caseYOff: 0,
    inspectR: 0.3,
    inspectM: 0.8,
    muzOff: 1.5,
    muzOffY: 0,
    muzMlt: 0.95,
    rate: 150,
    spread: 60,
    zoom: 1.4,
    leanMlt: 1,
    recoil: 0.006,
    recoilR: 0.02,
    recover: 0.98,
    recoverY: 0.99,
    recoverF: 0.98,
    recoilYM: 0.2,
    aimRecMlt: 0.4,
    recoilZ: 3.8,
    recoilZM: -0.4,
    recoilAnim: {
      time: 200,
      recoilTweenY: 0.28,
      recoilTweenZ: 0.1,
    },
    rumble: 0.4,
    icnPad: -15,
    expScale: 0.8,
  },
  {
    name: "Submachine Gun",
    src: "weapon_4",
    icon: "icon_4",
    sound: "weapon_4",
    secondary: false,
    noSpread: false,
    nAuto: false,
    noAim: false,
    akimbo: false,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 18,
      spd: 2.4,
      lookDir: true,
      grav: 0.00011,
      scale: 1.4,
      length: 10,
      range: 2700,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    swapWiggle: 0.5,
    attach: 0,
    attachYOff: -0.09,
    attachZOff: -1.1,
    zRot: 0.75,
    noAo: true,
    type: 0,
    shine: 50,
    swapTime: 300,
    aimSpd: 110,
    spdMlt: 1.04,
    ammo: 34,
    reload: 1000,
    dmg: 18,
    hsMlt: 1.5,
    pierce: 1,
    range: 700,
    dmgDrop: 12,
    scale: 0.000574897587939697,
    leftHoldY: -0.4,
    leftHoldX: -0.1,
    leftHoldZ: 1.1,
    rightHoldZ: -0.95,
    rightHoldY: -0.5,
    holdW: 0.85,
    xOff: 0.85,
    yOff: -0.86,
    zOff: -3,
    xOrg: 0,
    yOrg: -0.59,
    zOrg: -2.5,
    cRot: 0.18,
    cLean: 0.16,
    inspectR: 0.2,
    inspectM: 1.2,
    caseYOff: -0.15,
    caseZOff: -0.4,
    muzOff: 2.15,
    muzOffY: 0.1,
    rate: 90,
    spread: 70,
    minSpread: 5,
    zoom: 1.65,
    jYMlt: 0.8,
    leanMlt: 1,
    recoil: 0.0034,
    recoilY: 0.77,
    recoilYM: 0.3,
    recoilR: 0.065,
    recover: 0.975,
    recoverY: 0.996,
    recoverF: 0.975,
    recoilZ: 3.4,
    recoilZM: -0.1,
    aimRecMlt: 0.6,
    recoilAnim: {
      time: 190,
      recoilTweenYM: 0.05,
      recoilTweenY: 0.06,
      recoilTweenZ: 0.14,
    },
    expScale: 0.8,
    rumble: 0.4,
    icnPad: 0,
  },
  {
    name: "Revolver",
    src: "weapon_5",
    icon: "icon_5",
    sound: "weapon_5",
    secondary: false,
    noSpread: false,
    akimbo: false,
    noAim: false,
    nAuto: true,
    noAo: true,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 66,
      spd: 2.3,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 2600,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    nCase: true,
    transp: true,
    kill: ["", 50],
    type: 0,
    swapTime: 200,
    swapWiggle: 0.4,
    aimSpd: 110,
    spdMlt: 1.04,
    ammo: 6,
    reload: 900,
    dmg: 66,
    hsMlt: 1.5,
    pierce: 0.85,
    dmgDrop: 10,
    scale: 0.000515531266331653,
    hDstOff: 1.6,
    leftHoldY: -1.3,
    rightHoldY: -0.8,
    leftHoldZ: -0.6,
    rightHoldZ: -0.72,
    rightHoldX: 0.1,
    holdW: 1.1,
    rotOff: -0.05,
    xOff: 0.7,
    yOff: -0.5,
    zOff: -3.5,
    xOrg: 0,
    yOrg: -0.31,
    zOrg: -3.5,
    jYMlt: 0.4,
    cLean: 0.2,
    cRot: 0.1,
    cDrop: 0.1,
    inspectR: 0.1,
    inspectM: 0.3,
    muzOff: 2.75,
    muzOffY: 0.2,
    muzMlt: 0.95,
    range: 700,
    rate: 390,
    spread: 100,
    zoom: 1.45,
    leanMlt: 1.6,
    recoil: 0.013,
    recoilR: 0.082,
    recover: 0.982,
    recoverY: 0.992,
    recoverF: 0.98,
    recoilYM: 0.5,
    aimRecMlt: 0.1,
    recoilZM: 0.01,
    recoilZ: 4,
    recoilAnim: {
      time: 350,
      recoilTweenY: 0.39,
      recoilTweenYM: 0.25,
    },
    expScale: 0.9,
    rumble: 0.7,
    icnPad: -10,
  },
  {
    name: "Shotgun",
    src: "weapon_6",
    icon: "icon_6",
    sound: "weapon_6",
    secondary: false,
    noSpread: false,
    noAim: false,
    akimbo: false,
    altSkin: {
      name: "Nova Pump",
      mid: 0,
      blocked: true,
      noSale: true,
      midT: 38,
      scl: 0.9,
      mScl: 1,
      zOff: 0.28,
      yOff: -0.5,
      seas: 2,
      weapon: 6,
      rarity: 0,
    },
    noAo: true,
    nAuto: true,
    nCase: true,
    nRing: true,
    swapWiggle: 0.4,
    shine: 35,
    type: 0,
    physRang: 35,
    physPow: 0.09,
    swapTime: 300,
    aimSpd: 120,
    spdMlt: 1,
    ammo: 2,
    reload: 1100,
    dmg: 50,
    hsMlt: 1.5,
    dmgDrop: 50,
    scale: 0.00082934281407035,
    rightHoldX: 0.1,
    leftHoldY: -0.6,
    rightHoldY: -0.6,
    leftHoldZ: 0.4,
    rightHoldZ: -1.3,
    holdW: 1,
    xOff: 0.95,
    yOff: -0.6,
    zOff: -3.8,
    xOrg: 0,
    yOrg: -0.3,
    zOrg: -2.8,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    jYMlt: 0.2,
    inspectR: 0.1,
    muzOff: 6,
    muzMlt: 1.8,
    inspectM: 1.9,
    range: 160,
    rate: 450,
    innac: 110,
    spread: 180,
    shots: 5,
    cSpread: [
      0.03, 0.02, -0.27, 0.02, 0.03, -0.31, 0.3, -0.01, 0.01, 0.28, 0.01, 0.02,
      -0.17, -0.22, -0.3, 0.31, 0.32, 0.28, 0.3, -0.2,
    ],
    minSpread: 20,
    zoom: 1.25,
    leanMlt: 1.6,
    recoil: 0.02,
    recoilR: 0.015,
    recover: 0.99,
    recoverF: 0.97,
    recoilZ: 2.1,
    recoilZM: 0.2,
    aimRecMlt: 0.67,
    recoilYM: 0.65,
    recoilAnim: {
      time: 340,
      recoilTweenY: 0.22,
    },
    jumpYM: 0.5,
    rumble: 0.8,
    icnPad: 10,
    expScale: 0.85,
  },
  {
    name: "Machine Gun",
    src: "weapon_7",
    icon: "icon_7",
    sound: "weapon_7",
    secondary: false,
    akimbo: false,
    noAim: false,
    nAuto: false,
    noSpread: false,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 18,
      spd: 2.3,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 3000,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    type: 0,
    attach: 0,
    swapWiggle: 0.3,
    attachYOff: -0.085,
    attachZOff: -0.74,
    zRot: 0.75,
    noAo: true,
    swapTime: 700,
    aimSpd: 200,
    spdMlt: 0.79,
    jumMlt: 0.85,
    ammo: 60,
    reload: 3500,
    dmg: 18,
    hsMlt: 1.5,
    pierce: 1,
    range: 700,
    dmgDrop: 10,
    jYMlt: 0.8,
    scale: 0.0008856008924623108,
    leftHoldY: -0.85,
    leftHoldX: 0.4,
    rightHoldX: -0.1,
    rightHoldY: -0.79,
    leftHoldZ: 1.1,
    rightHoldZ: -0.2,
    holdW: 1.1,
    yRot: -0.01,
    xOff: 0.95,
    yOff: -0.75,
    zOff: -2.8,
    xOrg: 0,
    yOrg: -0.6,
    zOrg: -1.8,
    cLean: 0.1,
    cRot: 0.1,
    cDrop: 0.1,
    inspectR: 0.2,
    inspectM: 0.6,
    caseInd: 2,
    caseZOff: -0.5,
    caseYOff: -0.1,
    muzOff: 5.5,
    muzOffY: -0.14,
    muzMlt: 1.7,
    rate: 130,
    spread: 300,
    minSpread: 10,
    zoom: 1.3,
    leanMlt: 1.6,
    recoil: 0.0032,
    recoilR: 0.04,
    recover: 0.98,
    recoverY: 0.9975,
    recoverF: 0.975,
    // recoilZ: 3.8,
    recoilYM: 0.25,
    recoilZ: 3,
    recoilZM: -0.1,
    aimRecMlt: 0.5,
    recoilAnim: {
      time: 200,
      recoilTweenY: 0.045,
      recoilTweenZ: 0.12,
    },
    jumpYM: 0.5,
    expScale: 0.85,
    rumble: 0.65,
    icnPad: 10,
    forceAttach: true,
  },
  {
    name: "Semi Auto",
    src: "weapon_8",
    icon: "icon_8",
    sound: "weapon_8",
    noSpread: false,
    secondary: false,
    noAim: false,
    akimbo: false,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 33,
      spd: 2.5,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 4000,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    altSkin: {
      name: "Nova Semi",
      blocked: true,
      noSale: true,
      mid: 0,
      midT: 0,
      seas: 3,
      weapon: 8,
      rarity: 0,
    },
    attach: 0,
    attachYOff: -0.08,
    attachZOff: -1.55,
    nAuto: true,
    zRot: 0.7,
    type: 0,
    noAo: true,
    swapWiggle: 0.4,
    swapTime: 300,
    aimSpd: 120,
    spdMlt: 1,
    ammo: 8,
    reload: 1500,
    dmg: 32,
    hsMlt: 1.5625,
    pierce: 0.2,
    range: 1000,
    dmgDrop: 0,
    scale: 0.00093686221105528,
    leftHoldY: -0.5,
    rightHoldY: -0.45,
    leftHoldZ: 0.4,
    rightHoldZ: -1.85,
    jYMlt: 0.6,
    xOff: 0.8,
    yOff: -0.6,
    zOff: -3.5,
    xOrg: 0,
    yOrg: -0.395,
    yRot: -0.005,
    zOrg: -3.4,
    rotOff: -0.02,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    inspectR: 0.2,
    inspectM: 1.4,
    muzOff: 4,
    muzOffY: -0.05,
    muzMlt: 1.1,
    rate: 120,
    spread: 250,
    caseZOff: -1.3,
    zoom: 2.1,
    recoil: 0.01,
    recoilR: 0.08,
    recover: 0.98,
    recoilY: 0.36,
    recoverY: 0.994,
    recoverF: 0.975,
    recoilYM: 0.6,
    recoilZ: 2,
    recoilZM: 0.2,
    aimRecMlt: 0.8,
    recoilAnim: {
      time: 250,
      recoilTweenY: 0.11,
      recoilTweenZ: 0.15,
    },
    jumpYM: 0.5,
    rumble: 0.75,
    icnPad: 10,
  },
  {
    name: "Rocket Launcher",
    src: "weapon_9",
    icon: "icon_9",
    sound: "weapon_9",
    noSpread: false,
    noAim: false,
    secondary: false,
    akimbo: false,
    nInsp: true,
    nSkill: true,
    nAuto: true,
    nCase: true,
    nRing: true,
    noAo: true,
    projectile: {
      mat: "BASIC",
      color: 16777179,
      explode: 35,
      dmg: 50,
      eDmg: 35,
      spd: 0.72,
      grav: 0.00008,
      nImp: true,
      lookDir: true,
      scale: 1.4,
      length: 10,
      range: 1500,
    },
    type: 0,
    swapTime: 400,
    swapWiggle: 0.4,
    aimSpd: 200,
    spdMlt: 0.9,
    physRang: 46,
    physPow: 0.095,
    ammo: 3,
    shots: 0,
    reload: 1500,
    hsMlt: 1.5,
    scale: 0.00076263407035176,
    leftHoldX: -0.1,
    leftHoldY: -0.36,
    rightHoldY: -0.3,
    leftHoldZ: 1.2,
    rightHoldX: -0.15,
    rightHoldZ: -0.45,
    holdW: 0.9,
    jYMlt: 0.4,
    xOff: 0.95,
    yOff: -0.56,
    zOff: -2.6,
    xOrg: 0,
    yOrg: -0.945,
    zOrg: -3,
    zRot: 0.9,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    muzOff: 5,
    muzOffY: 0,
    muzMlt: 1.5,
    rate: 350,
    spread: 120,
    minSpread: 15,
    zoom: 1.5,
    leanMlt: 1.4,
    landBob: 0.8,
    recoil: 0.008,
    recoilR: 0.012,
    recover: 0.99,
    recoverY: 0.998,
    recoverF: 0.975,
    recoilZ: 4,
    recoilZM: -0.5,
    aimRecMlt: 0.9,
    recoilAnim: {
      time: 400,
      recoilTweenY: 0.25,
    },
    jumpYM: 0.3,
    expScale: 0.7,
    rumble: 1,
    rumbleDur: 750,
    icnPad: 10,
  },
  {
    name: "Akimbo Uzi",
    src: "weapon_10",
    icon: "icon_10",
    sound: "weapon_10",
    secondary: false,
    nAuto: false,
    noAo: true,
    physRang: 0,
    physPow: 0,
    altSkin: {
      name: "Nova Uzi",
      mid: 0,
      midT: 0,
      blocked: true,
      noSale: true,
      weapon: 10,
      rarity: 0,
      seas: 3,
    },
    nInsp: true,
    noAim: true,
    akimbo: true,
    type: 0,
    swapTime: 300,
    aimSpd: 120,
    spdMlt: 1.04,
    ammo: 18,
    reload: 1300,
    dmg: 14,
    hsMlt: 1.5,
    pierce: 1,
    range: 700,
    dmgDrop: 13,
    scale: 0.9,
    rightHoldY: -0.55,
    leftHoldZ: 0.2,
    leftHoldX: -0.1,
    leftHoldY: -0.55,
    rightHoldZ: 0.2,
    rightHoldX: -0.1,
    holdW: 1.3,
    xOff: 1.5,
    yOff: -0.95,
    zOff: -3.3,
    xOrg: 0,
    yOrg: -0.62,
    zOrg: -2.5,
    zLnM: 0.4,
    cLean: 0.1,
    cRot: 0.1,
    cDrop: 0.2,
    caseYOff: -0.15,
    caseZOff: -0.4,
    muzOff: 3.6,
    rate: 70,
    spread: 40,
    noSpread: false,
    movSpread: 0.1,
    minSpread: 10,
    zoom: 1.5,
    recoil: 0.0034,
    recoilR: 0.015,
    leanMlt: 0.6,
    recover: 0.978,
    recoverY: 0.996,
    recoverF: 0.975,
    recoilZ: 5,
    recoilYM: 0.7,
    recoilAnim: {
      recoilTweenY: 0.01,
    },
    expScale: 0.7,
    rumble: 0.4,
    icnPad: -4,
  },
  {
    name: "Desert Eagle",
    src: "weapon_11",
    icon: "icon_11",
    sound: "weapon_11",
    noSpread: false,
    akimbo: false,
    secondary: true,
    noAim: false,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 50,
      spd: 2.3,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 1500,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    minRec: 15,
    nAuto: true,
    noAo: true,
    transp: true,
    kill: ["", 50],
    type: 1,
    swapTime: 200,
    aimSpd: 110,
    spdMlt: 1,
    ammo: 6,
    reload: 1000,
    dmg: 50,
    hsMlt: 1.5,
    pierce: 0.85,
    dmgDrop: 10,
    scale: 0.94,
    leftHoldY: -0.9,
    rightHoldY: -0.7,
    leftHoldZ: -0.5,
    rightHoldZ: -0.5,
    holdW: 1.1,
    xOff: 1,
    yOff: -0.5,
    zOff: -4.1,
    xOrg: 0,
    yOrg: -0.195,
    zOrg: -3.8,
    cLean: 0.3,
    cRot: 0.3,
    inspectR: 0.35,
    inspectM: 0.9,
    muzOff: 2,
    muzMlt: 1.1,
    range: 700,
    rate: 400,
    spread: 150,
    jYMlt: 0.5,
    zoom: 1.4,
    leanMlt: 1.6,
    recoil: 0.01,
    recoilR: 0.01,
    recover: 0.982,
    recoverY: 0.995,
    recoverF: 0.98,
    recoilYM: 0.62,
    aimRecMlt: 0.23,
    recoilZ: 4.8,
    recoilZM: 0.2,
    recoilAnim: {
      time: 240,
      recoilTweenY: 0.42,
    },
    rumble: 0.8,
    icnPad: -10,
    expScale: 1.55,
  },
  {
    name: "Alien Blaster",
    src: "weapon_12",
    icon: "icon_12",
    sound: "weapon_12",
    akimbo: false,
    noSpread: false,
    noAim: false,
    noAo: true,
    physRang: 0,
    physPow: 0,
    secondary: true,
    nRing: true,
    nAuto: true,
    transp: true,
    nCase: true,
    minRec: 50,
    kill: ["", 50],
    type: 1,
    swapTime: 200,
    aimSpd: 120,
    spdMlt: 1,
    ammo: 4,
    reload: 1500,
    dmg: 50,
    hsMlt: 1.5,
    pierce: 0.85,
    dmgDrop: 10,
    scale: 1.1,
    leftHoldY: -1,
    rightHoldY: -0.65,
    leftHoldZ: -0.2,
    rightHoldZ: -0.2,
    holdW: 1,
    xOff: 1.3,
    yOff: -0.83,
    zOff: -4.1,
    xOrg: 0,
    yRot: -0.01,
    yOrg: -0.53,
    zOrg: -3.8,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0,
    inspectR: 0.1,
    inspectM: 0.8,
    muzOff: 2.2,
    muzOffY: 0.1,
    muzID: 3,
    muzMlt: 1.1,
    jYMlt: 0.8,
    range: 700,
    rate: 170,
    spread: 150,
    zoom: 1.4,
    leanMlt: 1.6,
    recoil: 0.006,
    recoilR: 0.01,
    recover: 0.98,
    recoverY: 0.99,
    recoverF: 0.98,
    recoilYM: 0.2,
    recoilZ: 2.2,
    aimRecMlt: 0.3,
    recoilAnim: {
      time: 200,
      recoilTweenY: 0.32,
    },
    rumble: 0.4,
    icnPad: -8,
    expScale: 1.85,
  },
  {
    name: "Combat Knife",
    icon: "icon_0",
    melee: true,
    noSkins: true,
    canThrow: true,
    aimLean: 0.01,
    holdW: 0.9,
    swapWiggle: 0.3,
    sound: "melee",
    insX: 0.1,
    inspAnim: {
      arZ: 0.3,
      arX: 0.6,
      arY: -2.2,
      apZ: -1.3,
      apX: -0.1,
      apY: 1,
      wpZ: -0.19,
      wpY: -0.4,
      wrY: -0.2,
    },
    anim: function (f, g, h) {
      if (h == 1) {
        f.handAnimInd = (f.handAnimInd || 1) * -1;
        var j = false;
        if (f.meleeAnim.anim) {
          f.meleeAnim.anim.stop();
          j = f.meleeAnim.armM >= 2;
        }
        f.resetMeleeAnim();
        var k = -1.2;
        var l = 0.7;
        var m = -0.4;
        if (j) {
          k += 0.1;
          f.meleeAnim.weaR = k;
          m += 0.8;
          f.meleeAnim.armR = m;
          l += 0.2;
          f.meleeAnim.weaM = l;
          f.meleeAnim.flipW = Math.PI;
        } else {
          k -= 0.4;
        }
        f.meleeAnim.anim = new g.Tween(f.meleeAnim)
          .to(
            {
              armR: m,
              lArm: 1,
              armT: j ? -0.2 : -0.8,
              armY: -3,
              armM: j ? -10 : 13,
              armE: -2,
              weaR: k,
              weaM: l,
            },
            (j ? 1.3 : 1) * 220,
          )
          .easing(g.Easing.Cubic.Out)
          .onComplete(function () {
            f.meleeAnim.anim = new g.Tween(f.meleeAnim)
              .to(
                {
                  armR: 0,
                  armT: 0,
                  armY: 0,
                  lArm: 0,
                  armM: 0,
                  armE: 0,
                  weaR: 0,
                  weaM: 0,
                  flipW: 0,
                },
                350,
              )
              .easing(g.Easing.Cubic.Out)
              .start();
          })
          .start();
      } else if (h == 2) {
        f.handAnimInd = (f.handAnimInd || 1) * -1;
        if (f.meleeAnim.anim) {
          f.meleeAnim.anim.stop();
        }
        f.resetMeleeAnim();
        var p = f.handAnimInd ? "lArm" : "";
        p = {};
        if (f.handAnimInd == 1) {
          p.lArm = -2.7;
        } else {
          p.rArm = -2.7;
        }
        f.meleeAnim.anim = new g.Tween(f.meleeAnim)
          .to(p, 10)
          .easing(g.Easing.Linear.None)
          .onComplete(function () {
            f.meleeAnim.anim = new g.Tween(f.meleeAnim)
              .to(
                {
                  lArm: 0,
                  rArm: 0,
                },
                150,
              )
              .easing(g.Easing.Linear.None)
              .delay(100)
              .start();
          })
          .start();
      } else if (h == 3) {
        if (f.meleeAnim.anim) {
          f.meleeAnim.anim.stop();
        }
        f.resetMeleeAnim();
        f.meleeAnim.armR = -1.3;
        f.meleeAnim.armM = 1.7;
        f.meleeAnim.armE = 1.1;
        f.meleeAnim.armY = 2.9;
        f.meleeAnim.armT = 1;
        f.meleeAnim.armS = 1.7;
        f.meleeAnim.weaR = -0.6;
        f.meleeAnim.anim = new g.Tween(f.meleeAnim)
          .to(
            {
              armY: -9,
              armS: -0.1,
              armE: -7.5,
              armM: -1.5,
              lArm: 0.5,
              weaR: -3,
            },
            300,
          )
          .easing(g.Easing.Cubic.Out)
          .onComplete(function () {
            f.meleeAnim.anim = new g.Tween(f.meleeAnim)
              .to(
                {
                  armR: 0,
                  armT: 0,
                  armY: 0,
                  lArm: 0,
                  armM: 0,
                  armS: 0,
                  armE: 0,
                  weaR: 0,
                },
                350,
              )
              .easing(g.Easing.Cubic.Out)
              .start();
          })
          .start();
      }
    },
    type: 2,
    swapTime: 250,
    aimSpd: 100,
    rate: 250,
    dmg: 50,
    dmgDrop: 0,
    range: 15,
    spdMlt: 1.1,
    spread: 100,
    leftHoldY: -0.82,
    leftHoldX: 1.5,
    rightHoldX: -1.5,
    rightHoldY: -0.82,
    leftHoldZ: -0.5,
    rightHoldZ: -0.5,
    xOff: 0,
    yOff: -0.6,
    zOff: -3.6,
    xOrg: 0.0001,
    yOrg: -0.6,
    zOrg: -3.6,
    zRM: 0.35,
    zoom: 1.2,
    leanMlt: 0.8,
    recoil: 0.006,
    recoilR: 0.01,
    recover: 0.98,
    recoverF: 0.98,
    rumble: 0.4,
    rumbleDur: 150,
    icnPad: -10,
  },
  {
    name: "Crossbow",
    src: "weapon_14",
    icon: "icon_14",
    sound: "weapon_14",
    noSpread: false,
    akimbo: false,
    secondary: false,
    noAim: false,
    nInsp: true,
    nRing: true,
    nAuto: true,
    noAo: true,
    physRang: 0,
    physPow: 0,
    nCase: true,
    nMuz: true,
    attach: 0,
    attachYOff: -0.1,
    attachZOff: 0.75,
    kill: ["", 75],
    type: 0,
    projectile: {
      mat: "BASIC",
      color: 16777179,
      spd: 0.68,
      dontPred: true,
      lookDir: true,
      scale: 0.7,
      dmg: 200,
      length: 10,
      range: 1500,
    },
    swapTime: 200,
    aimSpd: 120,
    spdMlt: 1,
    ammo: 1,
    reload: 900,
    dmg: 100,
    hsMlt: 1.5,
    pierce: 0,
    dmgDrop: 0,
    scale: 0.0007303348040201011,
    leftHoldY: -0.33,
    rightHoldY: -0.28,
    leftHoldZ: 2.2,
    leftHoldX: 0,
    rightHoldZ: 0.9,
    xOff: 1,
    yOff: -1,
    zOff: -1.4,
    xOrg: 0,
    yOrg: -0.72,
    zOrg: -0.7,
    cLean: 0.1,
    cRot: 0.1,
    zRot: 0.9,
    cDrop: 0.2,
    holdW: 0.5,
    muzOff: 2.2,
    muzOffY: 0.1,
    muzID: 3,
    muzMlt: 1.1,
    jYMlt: 0.95,
    range: 700,
    rate: 150,
    spread: 120,
    zoom: 1.4,
    leanMlt: 0.3,
    recoil: 0.007,
    recoilR: 0.01,
    recover: 0.985,
    recoverY: 0.996,
    recoverF: 0.98,
    recoilZ: 4,
    recoilAnim: {
      time: 300,
      recoilTweenY: 0.1,
    },
    rumble: 0.5,
    icnPad: 9,
  },
  {
    name: "Famas",
    src: "weapon_15",
    icon: "icon_15",
    sound: "weapon_15",
    akimbo: false,
    noSpread: false,
    secondary: false,
    noAim: false,
    noAo: true,
    nAuto: true,
    projectile: {
      disable: true,
      mat: "BASIC",
      color: 16777179,
      dmg: 28,
      spd: 2.4,
      lookDir: true,
      grav: 0.0001,
      scale: 1.4,
      length: 10,
      range: 3000,
      snd: 0,
    },
    physRang: 0,
    physPow: 0,
    burst: {
      c: 3,
      r: 90,
    },
    swapWiggle: 0.6,
    attach: 0,
    attachYOff: -0.1,
    attachZOff: -0.5,
    zRot: 1,
    type: 0,
    swapTime: 300,
    aimSpd: 130,
    spdMlt: 0.95,
    ammo: 30,
    rate: 280,
    reload: 1200,
    dmg: 28,
    hsMlt: 1.5,
    pierce: 1,
    range: 900,
    dmgDrop: 5,
    scale: 0.0008858419597989991,
    leftHoldY: -0.45,
    rightHoldY: -0.5,
    leftHoldZ: 0.72,
    rightHoldZ: -0.75,
    holdW: 1,
    xOff: 1,
    yOff: -0.86,
    yRot: 0.0018,
    zOff: -3,
    xOrg: 0,
    yOrg: -1.14,
    zOrg: -2,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    inspectR: 0.1,
    inspectM: 1.5,
    caseZOff: -1.7,
    caseYOff: -0.2,
    muzOff: 4.9,
    muzOffY: -0.05,
    muzMlt: 1.4,
    spread: 90,
    minSpread: 5,
    zoom: 1.5,
    leanMlt: 1.5,
    recoil: 0.003,
    recoilR: 0.02,
    recover: 0.978,
    recoverY: 0.995,
    recoverF: 0.975,
    jYMlt: 0.9,
    recoilYM: 0.32,
    recoilZ: 5.5,
    recoilZM: 0.05,
    aimRecMlt: 0.65,
    recoilAnim: {
      time: 300,
      recoilTweenY: 0.06,
      recoilTweenZ: 0.1,
    },
    jumpYM: 0.6,
    rumble: 0.5,
    expScale: 0.9,
    icnPad: 9,
  },
  {
    name: "Sawed Off",
    src: "weapon_16",
    icon: "icon_16",
    sound: "weapon_6",
    noSpread: false,
    akimbo: false,
    noAim: false,
    noAo: true,
    nAuto: true,
    nCase: true,
    nRing: true,
    secondary: true,
    minRec: 20,
    swapWiggle: 0.4,
    shine: 35,
    type: 1,
    physRang: 36,
    physPow: 0.1,
    swapTime: 200,
    aimSpd: 100,
    spdMlt: 1,
    ammo: 1,
    reload: 1100,
    dmg: 12,
    hsMlt: 1.5,
    dmgDrop: 12,
    scale: 1,
    rightHoldX: 0.1,
    leftHoldY: -0.5,
    rightHoldY: -0.6,
    leftHoldZ: 0.4,
    rightHoldZ: -1.5,
    holdW: 1,
    xOff: 0.95,
    yOff: -0.65,
    zOff: -3.8,
    xOrg: 0,
    yOrg: -0.3,
    zOrg: -2.8,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    jYMlt: 0.2,
    inspectR: 0.1,
    inspectM: 1.9,
    muzOff: 6,
    muzMlt: 1.8,
    range: 210,
    rate: 400,
    innac: 110,
    spread: 120,
    shots: 5,
    cSpread: [0.01, 0.05, -0.17, -0.22, -0.3, 0.31, 0.32, 0.28, 0.3, -0.2],
    minSpread: 20,
    zoom: 1.25,
    leanMlt: 1.6,
    recoil: 0.02,
    recoilR: 0.015,
    recover: 0.99,
    recoverF: 0.97,
    recoilZ: 2.1,
    recoilZM: 0.32,
    aimRecMlt: 0.3,
    recoilYM: 1,
    recoilAnim: {
      time: 340,
      recoilTweenY: 0.35,
    },
    jumpYM: 0.5,
    rumble: 0.8,
    icnPad: 10,
    expScale: 1,
  },
  {
    name: "Auto Pistol",
    src: "weapon_17",
    icon: "icon_17",
    sound: "weapon_17",
    noSpread: false,
    akimbo: false,
    secondary: true,
    noAim: false,
    nAuto: false,
    minRec: 30,
    noAo: true,
    physRang: 0,
    physPow: 0,
    noHeadShot: true,
    kill: ["", 50],
    type: 1,
    swapTime: 200,
    aimSpd: 100,
    spdMlt: 1,
    ammo: 15,
    reload: 1000,
    dmg: 16,
    hsMlt: 1.5,
    pierce: 0.95,
    dmgDrop: 2,
    scale: 0.0003158947055276376,
    leftHoldY: -1.1,
    rightHoldY: -0.62,
    leftHoldZ: -0.3,
    rightHoldZ: -0.32,
    rightHoldX: 0.13,
    holdW: 1.35,
    xOff: 1.2,
    yOff: -0.6,
    zOff: -3.7,
    xOrg: 0,
    yRot: -0.005,
    yOrg: -0.23,
    zOrg: -3.9,
    cLean: 0.3,
    cRot: 0.3,
    inspectR: 0.35,
    inspectM: 0.9,
    muzOff: 2,
    muzMlt: 1.1,
    range: 700,
    rate: 100,
    spread: 150,
    jYMlt: 0.5,
    zoom: 1.3,
    leanMlt: 1.6,
    recoil: 0.004,
    recoilR: 0.01,
    recover: 0.98,
    recoverY: 0.99,
    recoverF: 0.98,
    recoilYM: 0.2,
    aimRecMlt: 0.4,
    recoilZ: 3.8,
    recoilZM: -0.4,
    recoilAnim: {
      time: 200,
      recoilTweenY: 0.28,
    },
    rumble: 0.8,
    icnPad: -10,
    expScale: 1.55,
  },
  {
    name: "Bomb",
    src: "weapon_18",
    icon: "icon_18",
    sound: "weapon_18",
    transp: true,
    bomb: true,
    equipment: true,
    nInsp: true,
    noAim: true,
    noAo: true,
    nCase: true,
    noCross: true,
    nMuz: true,
    type: 3,
    aimSpd: 140,
    swapTime: 250,
    spdMlt: 0.65,
    scale: 0.63,
    holdW: 1.2,
    zoom: 1,
    rot: [0, Math.PI / 2, -0.4],
    leftHoldY: -0.3,
    rightHoldY: -0.3,
    leftHoldZ: 0.33,
    rightHoldX: -0.82,
    leftHoldX: 0.82,
    rightHoldZ: 0.33,
    xOff: 0,
    yOff: -0.8,
    zOff: -3.5,
    xOrg: 0.0001,
    yOrg: 0.0001,
    zOrg: 0.0001,
    cLean: 0,
    cRot: 0,
    cDrop: 0.12,
    jYMlt: 0.95,
    spread: 120,
    recover: 0.98,
    recoverF: 0.98,
    leanMlt: 0.3,
    icnPad: 9,
  },
  {
    name: "Blaster",
    src: "weapon_19",
    icon: "icon_19",
    sound: "weapon_19",
    secondary: false,
    noSpread: false,
    akimbo: false,
    noAim: false,
    noAo: true,
    nCase: true,
    nAuto: false,
    physRang: 0,
    physPow: 0,
    swapWiggle: 0.3,
    attach: 0,
    attachYOff: -0.07,
    attachZOff: -0.73,
    zRot: 1,
    type: 0,
    kill: ["", 75],
    swapTime: 300,
    aimSpd: 130,
    spdMlt: 0.95,
    ammo: 16,
    rate: 160,
    reload: 1600,
    dmg: 1,
    projectile: {
      mat: "BASIC",
      color: 9109499,
      spd: 1,
      grav: 0,
      nImp: true,
      lookDir: true,
      scale: 0.7,
      dmg: 35,
      length: 10,
      range: 500,
    },
    hsMlt: 1.5,
    pierce: 1,
    range: 700,
    dmgDrop: 5,
    scale: 0.0007946847095477368,
    leftHoldY: -0.8,
    rightHoldY: -0.6,
    leftHoldZ: 1.2,
    rightHoldZ: -1.25,
    holdW: 0.75,
    xOff: 0.7,
    yOff: -0.76,
    zOff: -3,
    rotOff: -0.05,
    rotOffA: -0.02,
    aimOffY: 0.042,
    yRot: 0.0018,
    xOrg: 0,
    yOrg: -0.52,
    zOrg: -2.3,
    cLean: 0.2,
    cRot: 0.2,
    cDrop: 0.1,
    inspectR: 0.1,
    inspectM: 1.5,
    caseZOff: -1.7,
    caseYOff: -0.2,
    muzID: 3,
    muzOff: 5.1,
    muzOffY: -0.08,
    muzMlt: 1.4,
    spread: 100,
    minSpread: 5,
    zoom: 1.6,
    leanMlt: 1.5,
    recoil: 0.003,
    recoilR: 0.05,
    recover: 0.978,
    recoverY: 0.995,
    recoverF: 0.975,
    jYMlt: 0.9,
    recoilYM: 0.4,
    recoilZ: 5.7,
    recoilZM: -0.05,
    aimRecMlt: 0.7,
    recoilAnim: {
      time: 300,
      recoilTweenY: 0.07,
      recoilTweenZ: 0.1,
    },
    jumpYM: 0.6,
    rumble: 0.5,
    icnPad: 5,
  },
];
module.exports.findWeaponBySrc = function (f) {
  for (var g = 0; g < module.exports.length; ++g) {
    if (module.exports[g].src == "weapon_" + f) {
      return module.exports[g];
    }
  }
  return null;
};
module.exports.findIndexBySrc = function (f) {
  for (var g = 0; g < module.exports.length; ++g) {
    if (module.exports[g].src == f) {
      return g;
    }
  }
  return null;
};
var c = [];
for (var d = 0; d < module.exports.length; ++d) {
  module.exports[d].id = d;
  if (!module.exports[d].melee && !module.exports[d].equipment) {
    c.push(d);
  }
}
module.exports.onlyWeapons = c;
